import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const faqs = [{
  question: '¿Necesito experiencia en finanzas?',
  answer: 'No. Existe un proceso de capacitación para conocer la industria y desarrollar las habilidades necesarias.'
}, {
  question: '¿Tengo que dejar mi trabajo actual?',
  answer: 'No. Puedes conocer cómo funciona y evaluar si encaja con tu situación y objetivos actuales.'
}, {
  question: '¿Necesito obtener una licencia?',
  answer: 'Algunas actividades dentro de la industria requieren capacitación y las licencias correspondientes. Durante la conversación te explicaremos el proceso.'
}, {
  question: '¿La reunión es presencial?',
  answer: 'Tú eliges. Podemos coordinar presencialmente en Doral, Florida, o por Zoom.'
}, {
  question: '¿La reunión me compromete a comenzar?',
  answer: 'No. El objetivo inicial es que conozcas cómo funciona, hagas tus preguntas y determines si tiene sentido para ti.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduced = useReducedMotion();
  return <section id="preguntas" className="w-full scroll-mt-16 bg-ivory py-24 sm:py-32 lg:py-40" aria-labelledby="faq-title" data-id="element-67" data-mp="fm4g7c8w100i">
      <div className="mx-auto grid max-w-page grid-cols-1 gap-12 px-5 sm:px-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-24 lg:px-12" data-id="element-68" data-mp="6r6no69njp9p">
        <Reveal data-id="element-69" data-mp="bjpwkpxe9w86">
          <h2 id="faq-title" className="font-sans text-[1.85rem] font-light uppercase leading-[1.12] text-ink sm:text-[2.5rem]" data-id="element-70" data-mp="bk9hmficd0qf">
            Antes de decidir,
            <br data-id="element-71" data-mp="1q94prgtir75" />
            es normal tener
            <br data-id="element-72" data-mp="3jxgi06bpuodn" />
            preguntas.
          </h2>
        </Reveal>

        <div className="border-t border-ink/15" data-id="element-73" data-mp="3nzk3lns3n9cn">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} className="border-b border-ink/12" data-id="element-74" data-mp="1uhmj19dvkdhw" data-mpi={i}>
                <h3 data-id="element-75" data-mp="1ppmbovvh6iba">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-6 py-7 text-left transition-colors duration-200 ease-out hover:text-steel" data-id="element-76" data-mp="1pp3345rpt69x">
                    <span className="font-sans text-[17px] font-light leading-snug text-ink sm:text-lg" data-id="element-77" data-mp="2ddmbelarlj20">
                      {faq.question}
                    </span>
                    {isOpen ? <MinusIcon className="mt-1 h-4 w-4 flex-none text-champagne" strokeWidth={1.5} aria-hidden="true" data-id="element-78" data-mp="23jdnyc0lcgap" /> : <PlusIcon className="mt-1 h-4 w-4 flex-none text-champagne" strokeWidth={1.5} aria-hidden="true" data-id="element-79" data-mp="o0ivif81tu4h" />}
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-80" data-mp="38p2boy688wj3">
                  {isOpen && <motion.div initial={reduced ? undefined : {
                height: 0,
                opacity: 0
              }} animate={reduced ? undefined : {
                height: 'auto',
                opacity: 1
              }} exit={reduced ? undefined : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-81" data-mp="3dfiqompp4q7k">
                      <p className="max-w-xl pb-8 pr-10 font-sans text-base font-light leading-relaxed text-steel sm:text-[17px]" data-id="element-82" data-mp="87jccn22uj9">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}